import React from "react";

function RightIcon({color}) {
   
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <g clipPath="url(#clip0_1_510)">
        <path
          d="M10.9999 0C4.91973 0 -6.10352e-05 4.92031 -6.10352e-05 11C-6.10352e-05 17.0802 4.92025 22 10.9999 22C17.0801 22 21.9999 17.0797 21.9999 11C21.9999 4.91979 17.0796 0 10.9999 0ZM10.9999 20.5333C5.74327 20.5333 1.46659 16.2567 1.46659 11C1.46659 5.74329 5.74327 1.46665 10.9999 1.46665C16.2566 1.46665 20.5333 5.74333 20.5333 11C20.5333 16.2567 16.2566 20.5333 10.9999 20.5333Z"
          fill='#48B057'
        />
        <path
          d="M16.8228 6.95789C16.5365 6.67151 16.0721 6.67151 15.7858 6.95789L9.25721 13.4864L6.21416 10.4434C5.92778 10.157 5.46341 10.157 5.17707 10.4434C4.89068 10.7298 4.89068 11.1941 5.17707 11.4805L8.73862 15.0421C9.02496 15.3284 9.48946 15.3283 9.77571 15.0421L16.8228 7.99494C17.1092 7.70856 17.1092 7.24428 16.8228 6.95789Z"
          fill='#48B057'
        />
      </g>
      <defs>
        <clipPath id="clip0_1_510">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default RightIcon;
